// extracted by mini-css-extract-plugin
export default {"modal":"PurchaseSuccess_modal__K4P0m","title":"PurchaseSuccess_title__d4t00","button":"PurchaseSuccess_button__r5rI3"};